<template>
  <el-select
    v-model="value"
    multiple
    :placeholder="placeholder"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { Device, DeviceTypeLabel, DeviceTypeLabels } from '@/api/types'

type DeviceEntry = {
  key: Device
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'DeviceSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: () => 'All'
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = DeviceTypeLabels.map<DeviceEntry>(
      (deviceLabel: DeviceTypeLabel) => {
        return {
          key: deviceLabel.type_id,
          label: deviceLabel.label,
          disabled: false
        }
      }
    )

    const update = (newValue: Array<Device>) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { options, update, value }
  }
})
</script>
